function formatDate(dateString: string) {
  const date = new Date(dateString);
  const day = date.getDate();

  const ordinal = (n: number) =>
    n > 3 && n < 21 ? 'th' : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][n % 10];

  const month = new Intl.DateTimeFormat('en', { month: 'short' }).format(date);

  return `${day}${ordinal(day)} ${month} ${date.getFullYear()}`;
}

function fetchBlogTypeStylings(blogType: string) {
  const typeStyling = {
    bg: "bg-[#FEF2FF]",
    border: "border-[#EB53FF]",
    text: "text-[#EB53FF]",
  };

  if (blogType === "Industry Insights") {
    typeStyling.bg = "bg-[#FDF6EB]";
    typeStyling.border = "border-[#F7AA1C]";
    typeStyling.text = "text-[#F7AA1C]";
  } else if (blogType === "News") {
    typeStyling.bg = "bg-[#EEFDEC]";
    typeStyling.border = "border-[#63E418]";
    typeStyling.text = "text-[#63E418]";
  }

  return typeStyling;
}


export { formatDate, fetchBlogTypeStylings };
